import React from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  Box,
  Typography,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import "./pdf-preview-popup.scss";

interface Props {
  open: boolean;
  onClose: () => void;
  fileUrl: string;
}

const PdfPreviewPopup: React.FC<Props> = ({ open, onClose, fileUrl }) => {
  // const defaultLayoutPluginInstance = defaultLayoutPlugin({
  //   sidebarTabs: (defaultTabs) => [defaultTabs[0]],
  // });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      className="pdf-preview-dialog"
      slotProps={{
        paper: {
          sx: {
            padding: "0px 0px 30px 0px !important",
            minWidth: '60vw',
            maxWidth: "70vw",
            height: "80vh",
            borderRadius: "16px",
            overflowX: "hidden !important",
          },
        },
      }}
    >
      {/* Header */}
      <DialogTitle className="pdf-header">
        <Typography>Preview</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          overflowY: "hidden !important",
          padding: "0px",
        }}
      >
        <Box className="pdf-body">
          <Box className="pdf-viewer">
            <Worker workerUrl="/pdf.worker.min.js">
              <Viewer
                fileUrl={fileUrl}
                theme="light"
                defaultScale={SpecialZoomLevel.PageWidth}
                // plugins={[defaultLayoutPluginInstance]}
              />
            </Worker>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PdfPreviewPopup;
